module.exports = __webpack_public_path__ + "frontend/img/icon_confirmation.f1b02506.svg";